<template>
  <q-page>
    <router-view></router-view>
  </q-page>
</template>

<script>
import module from '../index'

export default {
  name: 'Entry',
  beforeCreate () {
    this.$registerModule(module)
  }
}
</script>
